import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { TableColumn } from '@ui/aos-lib';
import { ReportGroups } from '../../report-groups.types';
import { NameWithDescriptionComponent } from '../../../../../shared/components/listing-table/components/name-with-description.component';

@Component({
  selector: 'aos-report-groups-name-column',
  template: `
    <aos-name-with-description [dataCell]="{ displayName: item.groupName, description: item.groupDescription }" />
  `,
  imports: [NameWithDescriptionComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportGroupNameColumnComponent {
  @Input() item!: ReportGroups;
  @Input() column!: TableColumn;
  @HostBinding('class') fullWidth = 'full-width';
}
